import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { ILanguagePicker } from '../_shared/models/language-picker/language-picker.model';
import { ILanguageLink } from '../_shared/models/language-picker/language-link.model';
import { Modal2Component } from '../modal/modal2/modal2.component';
import { HeadingComponent } from '../heading/heading.component';
import { TabGroupComponent } from '../tabs/tab-group/tab-group.component';
import { TabComponent } from '../tabs/tab.component';
import { IconComponent } from '../icon/icon.component';
import { SectionComponent } from '../section/section.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CheckmarkComponent } from '../checkmark/checkmark.component';

@Component({
    selector: 'sirius-language-picker',
    templateUrl: './language-picker.component.html',
    styleUrls: ['./language-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-m-default' },
    imports: [
        Modal2Component,
        HeadingComponent,
        TabGroupComponent,
        TabComponent,
        SectionComponent,
        IconComponent,
        CommonModule,
        TranslateModule,
        CheckmarkComponent,
    ],
})
export class LanguagePickerComponent {
    readonly languages = input.required<ILanguagePicker>();
    readonly closeEvent = output<ILanguageLink | void>();

    /** Drives sirius-modal2; defaults open so the standalone element renders the dialog on mount. */
    readonly open = signal(true);

    /** Referenced by modal2's aria-labelledby so the dialog is named by its heading. */
    readonly titleId = 'sirius-language-picker-title';

    isItemSelected(name: string): boolean {
        return name === this.languages().selected.shortName;
    }

    onLanguageSelect(): void {
        this.open.set(false);
        this.closeEvent.emit();
    }
}
